document.addEventListener('DOMContentLoaded', function () {

    function initSlider(sectionSelector, sliderSelector, itemSelector, prevSelector, nextSelector) {
        const sections = document.querySelectorAll(sectionSelector);

        sections.forEach(section => {
            const slider = section.querySelector(sliderSelector);
            const prevArrow = section.querySelector(prevSelector);
            const nextArrow = section.querySelector(nextSelector);
            const thumb = section.querySelector('.custom-scrollbar__thumb');
            const scrollbar = section.querySelector('.custom-scrollbar');

            if (!slider) return;

            function updateScrollbar() {
                if (!thumb || !scrollbar) return;
                
                const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
                if (maxScrollLeft <= 0) return;

                const scrollPercentage = slider.scrollLeft / maxScrollLeft;
                
                const maxThumbTravel = scrollbar.clientWidth - thumb.clientWidth;
                const thumbPosition = scrollPercentage * maxThumbTravel;

                thumb.style.transform = `translateX(${thumbPosition}px)`;
            }

            function updateArrowStates() {
                const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
                prevArrow?.classList.toggle('disabled', slider.scrollLeft <= 5);
                nextArrow?.classList.toggle('disabled', slider.scrollLeft >= maxScrollLeft - 5);
            }

            function calculateScrollAmount() {
                const item = slider.querySelector(itemSelector);
                if (!item) return;
                const gap = 20; 
                const itemsVisible = Math.floor(slider.clientWidth / item.offsetWidth) || 1;
                return (item.offsetWidth + gap) * itemsVisible;
            }

            slider.addEventListener('scroll', () => {
                updateArrowStates();
                updateScrollbar();
            });

            prevArrow?.addEventListener('click', () => {
                const amount = calculateScrollAmount();
                slider.scrollBy({ left: -amount, behavior: 'smooth' });
            });

            nextArrow?.addEventListener('click', () => {
                const amount = calculateScrollAmount();
                slider.scrollBy({ left: amount, behavior: 'smooth' });
            });

            window.addEventListener('resize', () => {
                updateArrowStates();
                updateScrollbar();
            });
            
            setTimeout(() => {
                updateArrowStates();
                updateScrollbar();
            }, 500);
        });
    }

    /* Landing Collection */
    initSlider(
        '.landing-collection',
        '.landing-collection__products',
        '.landing-collection__item',
        '.slider-arrow--prev',
        '.slider-arrow--next'
    );

});